var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.header == true),
      expression: "header == true"
    }],
    attrs: {
      "align": "center",
      "id": "bit00_3"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('b-nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.header == true),
      expression: "header == true"
    }],
    staticClass: "ml-auto",
    staticStyle: {
      "margin-right": "1%"
    },
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "no-caret": "",
      "disabled": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticStyle: {
      "color": "#fff",
      "cursor": "default"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "font-size": "22px",
      "color": "red",
      "padding-left": "10px"
    }
  }), _vm._v(" " + _vm._s(_vm.currentHubName) + " ")])])], 2), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/default-img.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none",
    staticStyle: {
      "color": "#fff !important"
    }
  }, [_vm._v(_vm._s(_vm.useremail))])]), _vm._v(" "), (_vm.isChangeDefaultHub) ? _c('b-dropdown-item', {
    on: {
      "click": _vm.changedefaulthub
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Change Default Hub")]) : _vm._e(), _vm._v(" "), (_vm.isChangePassword) ? _c('b-dropdown-item', {
    on: {
      "click": _vm.ChangePassword
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Change Password")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 2)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slider round",
    attrs: {
      "title": "Toggle Menubar"
    }
  }, [_c('span', {
    staticClass: "on"
  }), _vm._v(" "), _c('span', {
    staticClass: "off"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a629efba","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 509
// module chunks = 3